export default __webpack_public_path__ + "static/media/copy-icon.ac191026.svg";